module.exports = __webpack_public_path__ + "static/media/01.55a1596a.gif";